import React from "react";

interface TermsSectionProps {
    number?: string;
    title: string;
    content: string;
}

const TermsSection: React.FC<TermsSectionProps> = ({ number, title, content }) => {
    const displayTitle = number ? `${number}. ${title}` : title;

    return (
        <section className="flex flex-col gap-4">
            <h3 className="text-lg font-bold text-black">
                {displayTitle}
            </h3>
            <p className="text-lg text-black text-justify">
                {content}
            </p>
        </section>
    );
};

export default TermsSection;